import {
  MapProvider,
  GeolocationInput,
  GeolocationAddress,
} from './map-provider';

export class GoogleMapsProvider extends MapProvider {
  name = 'Google Maps';

  generateUrl(destination: GeolocationInput): string {
    const destStr = this.formatLocation(destination);

    if (this.isCoordinates(destination)) {
      return `${GoogleMapsProvider.URL_PREFIX}/place/${destination.latitude},${destination.longitude}`;
    }

    return `${GoogleMapsProvider.URL_PREFIX}/search/${encodeURIComponent(destStr)}`;
  }

  private formatLocation(location: GeolocationInput): string {
    if (typeof location === 'string') {
      return location;
    }

    if (this.isCoordinates(location)) {
      return `${location.latitude},${location.longitude}`;
    }

    return this.formatAddress(location);
  }

  private formatAddress(address: GeolocationAddress): string {
    const parts = [
      address.locationName,
      address.address,
      address.city,
      address.state,
      address.zipCode,
      address.country,
    ].filter((p) => p != null && p !== '');

    return parts.join(', ');
  }

  private static URL_PREFIX = 'https://www.google.com/maps';
}
